export default __webpack_public_path__ + "static/media/shortbrownrocks.555121f4.png";